<template>
	<div
		class="toggleswitch-box"
		:class="{ 'toggleswitch-box--small': size === 'small' }"
	>
		<label class="toggleswitch-box__box" @click="changingValue">
			<div :class="['toggleswitch-box__v', { true: checkSts }]">
				<div class="toggleswitch-box__ball"></div>
			</div>
		</label>
		<p class="toggleswitch-box__text">{{ getText }}</p>
	</div>
</template>

<script>
	export default {
		name: 'ToggleswitchBox',
		props: ['checkSts', 'checkObj', 'unCheckObj', 'size'],
		methods: {
			changingValue() {
				this.$emit(
					'changingVal',
					this.checkSts ? this.unCheckObj : this.checkObj
				);
			},
		},
		computed: {
			getText() {
				return (this.checkSts ? this.checkObj : this.unCheckObj).text;
			},
		},
	};
</script>

<style lang="scss" scoped>
	DIV.toggleswitch-box {
		&:after {
			content: '';
			display: block;
			clear: both;
		}

		.toggleswitch-box__box {
			float: left;
			cursor: pointer;
			display: block;
			width: 48px;
			height: 25px;
		}

		.toggleswitch-box__v {
			display: block;
			width: 100%;
			height: 100%;
			background: #dfe6ee;
			border-radius: 12.5px;
			transition: all ease 0.1s;

			&.true {
				background: $btn-blue;

				.toggleswitch-box__ball {
					margin-left: 23px;
					border-color: $btn-blue;
				}
			}
		}

		.toggleswitch-box__ball {
			display: block;
			width: 25px;
			height: 100%;
			margin-left: 0;
			background: #fff;
			border: solid 4px #dfe6ee;
			border-radius: 50%;
			transition: all ease 0.1s;
		}

		.toggleswitch-box__text {
			display: block;
			float: right;
			line-height: 25px;
			font-size: 0.875rem;
			font-weight: normal;
		}
	}

	DIV.toggleswitch-box--small {
		.toggleswitch-box__box {
			width: 30px;
			height: 20px;
		}

		.toggleswitch-box__ball {
			width: 20px;
		}

		.toggleswitch-box__v {
			&.true {
				.toggleswitch-box__ball {
					margin-left: 10px;
				}
			}
		}
	}
</style>
